module.exports = __webpack_public_path__ + "media/images/british-open-card.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/british-open-card.jpg
// module id = 64
// module chunks = 0